import React from "react";

// 1. Import the provider from the reCAPTCHA library
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { getRecaptchaSiteKey } from "./siteConfig";

// 2. Import your global stylesheet
import "./App.css";

// 3. Import your page components (adjust paths as needed)
// It's common practice to keep components in a 'components' folder.
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Projects from "./components/Projects";
import About from "./components/About";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Skills from "./components/Skills";
import WorkHistory from "./components/WorkHistory";
import Volunteering from "./components/Volunteering";
import ReplikitFeatured from "./components/ReplikitFeatured";

function App() {
  const recaptchaKey = getRecaptchaSiteKey();

  const appContent = (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <About />
        <WorkHistory />
        <ReplikitFeatured />
        <Projects />
        <Education />
        <Volunteering />
        <Skills />
        <Contact recaptchaEnabled={Boolean(recaptchaKey)} />
      </main>
      <Footer />
    </div>
  );

  if (!recaptchaKey) {
    return appContent;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey} useRecaptchaNet>
      {appContent}
    </GoogleReCaptchaProvider>
  );
}

export default App;
